import { RegisterForm } from "@/features/auth/register/RegisterForm/RegisterForm";
import AuthVk from "@/features/auth/VkAuth/vkAuth";
import { useRegister } from "@/shared/hooks/useAuth";
import { type RegisterFormData } from "@/shared/lib/validation";
import { AxiosError } from "axios";
import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./RegisterPage.module.css";

export const RegisterPage: React.FC = observer(() => {
  const navigate = useNavigate();
  const registerMutation = useRegister();

  const handleRegister = async (data: RegisterFormData) => {
    try {
      const { ...apiData } = data;
      await registerMutation.mutateAsync(apiData);
      navigate("/verify/check-email", { state: { email: data.email } });
    } catch (error) {
      console.error("Register error:", error);
    }
  };

  const getErrorMessage = (): string => {
    if (!registerMutation.error) return "";

    const error = registerMutation.error as AxiosError;
    const errorStatus = error?.response?.status;

    switch (errorStatus) {
      case 400:
        return "Пользователь с таким email уже существует";
      case 422:
        return "Некорректные данные для регистрации";
      case 409:
        return "Пользователь с таким email уже зарегистрирован";
      default:
        return `Ошибка при регистрации: ${errorStatus || "неизвестная ошибка"}`;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        <div className={styles.backgroundBlur1} />
        <div className={styles.backgroundBlur2} />
        <div className={styles.backgroundBlur3} />
      </div>

      <div className={styles.content}>
        <RegisterForm
          onSubmit={handleRegister}
          isLoading={registerMutation.isPending}
          error={getErrorMessage()}
        />
        <AuthVk />
      </div>
    </div>
  );
});
